import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import {
    ADVISER,
    hasRole,
    MANAGER,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
} from '../../../../utils/userRoles';
import CheckBox from '../../../formElements/CheckBox';
import DateSelect from '../../../formElements/DateSelect';
import RadioButtons from '../../../formElements/RadioButtons';

import classes from '../../../../commonStyles/tables.module.css';
import barriersClasses from './barriers.module.css';

const acceptedRoles = [ADVISER, MANAGER, QUALITY, RECRUITMENT_MANAGER, SUPERUSER];

const SelectBarriersTableRow = ({ row, roles, onRowChange }) => {
    // EVENT HANDLERS
    const onUpdate = (key, value) => {
        onRowChange({ ...row, [key]: value });
    };

    const onCheck = (e) => {
        onRowChange({ ...row, update: e.target.checked });
    };

    // RENDER
    return (
        <TableRow key={row.id} hover className={classes.basicRowStripes}>
            <TableCell disabled={!hasRole(acceptedRoles, roles)}>
                <div className={barriersClasses.check}>
                    <CheckBox id={row.id} checked={row.update} onChange={onCheck} />
                </div>
            </TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>
                <RadioButtons
                    id={`priority-${row.id}`}
                    disabled={row.update !== true}
                    radioButtons={[
                        { id: 'Low', onChangeVal: 'Low' },
                        { id: 'Medium', onChangeVal: 'Medium' },
                        { id: 'High', onChangeVal: 'High' }
                    ]}
                    customClass="tableRowRadioWrapper"
                    value={row.priority}
                    onChange={(option) => onUpdate('priority', option)}
                />
            </TableCell>
            <TableCell>
                <DateSelect
                    id="startDate"
                    label=""
                    disabled={row.update !== true}
                    value={row.startDate}
                    customClass="rowField"
                    onDateChange={(date) => onUpdate('startDate', date)}
                />
            </TableCell>
            <TableCell>
                <DateSelect
                    id="dueDate"
                    label=""
                    disabled={row.update !== true}
                    value={row.dueDate}
                    customClass="rowField"
                    onDateChange={(date) => onUpdate('dueDate', date)}
                />
            </TableCell>
        </TableRow>
    );
};

SelectBarriersTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    onRowChange: PropTypes.func
};

export default SelectBarriersTableRow;
